<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import AIBuddyIcon from '../../AIBuddyIcon.vue';
    import LoadingDots from '../../LoadingDots.vue';

    defineProps<{
        show: boolean;
    }>();
</script>
<template>
    <Teleport to="body">
        <Transition name="fade">
            <div
                v-if="show"
                class="fixed top-0 left-0 h-full w-screen bg-white z-loading-screen flex justify-center items-center"
            >
                <div class="flex flex-col items-center gap-12 relative">
                    <div class="absolute -top-90 h-67">
                        <AIBuddyIcon />
                    </div>
                    <div class="absolute -top-12">
                        <LoadingDots />
                    </div>
                    <h2 class="heading-lg">
                        {{ __('ai-coaching-in-progress') }}
                    </h2>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>
